//Global Functions
window.PARCELE = [];

import TileWMS from 'ol/source/TileWMS.js';
import * as access from "../js/main.js";
const {map} = access;

export function changeAnParcele() {
	
	var parcels_year_selected = $('#parcels_year_select').find(":selected").val();
	console.log('changeAnParcele to: ' + parcels_year_selected); 
	
	//list year parcele tabele
	for(var i=0;i<window.PARCELE.length;i++) {
		if(parseInt(window.PARCELE[i]['year']) == parseInt(parcels_year_selected)) {
			
			//Fill Info
			var html = ''
			html += '<table class="table table-condensed"><thead><tr> <th>Cultură</th> <th>Parcelă</th> <th>Semănare</th> <th>Densitate semănare</th> <th>Recoltare</th> <th>Randament</th> <th>Sol</th> </tr> </thead> <tbody>';
			for(var j=0;j<window.PARCELE[i]['data'].length;j++) {
				html += '<tr data-id="' + window.PARCELE[i]['data'][j]['ID'] + '"> <td>' + window.PARCELE[i]['data'][j]['Cultura'] + '</td> <td>' + window.PARCELE[i]['data'][j]['Denumire_parcela'] + '</td> <td>' + window.PARCELE[i]['data'][j]['Densitate_semanare'] + '</td> <td>' + window.PARCELE[i]['data'][j]['Densitate_semanare'] + '</td> <td>' + window.PARCELE[i]['data'][j]['Data_recoltare'] + '</td> <td>' + window.PARCELE[i]['data'][j]['Randament_cultura'] + '</td> <td>' + window.PARCELE[i]['data'][j]['Analize_sol'] + '</td>  </tr>';	
			}//endfor j

			html += '</tbody></table>';
			$("#parcels_info").html(html);
			
		
			//Update WMS Layer
			var newSource = new TileWMS({
					  url: 'https://agri.terrasigna.com/geoserver/wms',
					  params: {'LAYERS': 'agri:' + window.PARCELE[i]['layer'] + '', 'TILED': true},
					  serverType: 'geoserver',
					  transition: 0,
				});
			window.layer_parcels.setSource(newSource);
			
			map.getView().fit([27.648228655751634, 46.391192278127136, 27.91470950062695, 46.51780375448783], {duration: 800});
			
			/*
			var onChangeKey = newSource.on('change', function() {
			  if (newSource.getState() == 'ready') {
				//console.log( vector_source_json.getExtent() );
				map.getView().fit(newSource.getExtent(), {duration: 800});
			  }
			});			
			*/
			
			
		}//endif year
	}//endfor i
	
}


export function getParcele() {
		console.log('Getting Parcele...');
		$.getJSON("getparcele.php", function(data) {
		  window.PARCELE = data['parcele'];
		  //console.log(window.PARCELE);
		  
		  //Change An Cultura Select
		  changeAnParcele();
		  
		  
		});
	
}
